"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Image = void 0;
var tslib_1 = require("tslib");
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
exports.Image = styled_components_1.default.img(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  border-radius: 50%;\n  object-fit: cover;\n  height: 100%;\n  width: 100%;\n"], ["\n  border-radius: 50%;\n  object-fit: cover;\n  height: 100%;\n  width: 100%;\n"])));
var templateObject_1;
//# sourceMappingURL=image.js.map